/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/26/20
 * Time: 2:19 PM
 */
import React, {Component} from 'react';
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import apiConfig from "../../../../axios/axios_api_services";
import * as common from "../../../../const/Common/CommonFunc";
import * as tableHeaders from "../../../../const/table/TableHeaders";
import * as keys from "../../../../const/key/Key";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Button as SementicBtn, Dropdown} from "semantic-ui-react";
import {MDBDataTable} from "mdbreact";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import Details from "./Details/Details";
import './TemporyList.scss';
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";
import {Tooltip} from "antd";

class App extends Component {
  state = {
    isView: false,
    selectObj: null,
    data: [], status: "ALL"
  };

  viewCorporate = (obj) => {
    this.setState({
      isView: !this.state.isView,
      selectObj: obj
    });
  };

  getData = () => {
    this.setState({isView: false});

    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.TEMP_CORPORATE, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.temporaryCorporateList
          })
        } else {
          this.setState({
            data: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getData()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    this.getData();
  }

  render() {
    let {status} = this.state;
    let rows = [];
    let all_corporates = this.state.data;
    if (all_corporates.length !== 0) {
      all_corporates.map((cor, index) => {
        if ((status === cor.temporaryCorporateStatus) || status === "ALL") {
          const obj = {
            photoPath: cor.photoPath === null || cor.photoPath === "" ? null :
              <img src={cor.photoPath} className="rounded mx-auto d-block cor-logo" alt="."/>,
            corporateName: cor.corporateName,
            fullName: cor.fullName,
            adminMobile: cor.adminMobile,
            adminEmail: cor.adminEmail,
            addedDate: common.convertDate(new Date(cor.addedDate)),
            status: cor.temporaryCorporateStatus,
            more:
              <Row style={{padding: '0px', margin: '0px'}}>
                <Col sm={12} style={{padding: '0px'}} className={"align-center"}>
                  <SementicBtn circular icon='eye' color={"facebook"}
                               onClick={() => this.viewCorporate(cor)}/>
                </Col>
              </Row>
          };
          rows.push(obj)
        }

      })
    }

    let table_data = {columns: tableHeaders.tempCorporateHeaders, rows: rows};
    return (
      <Row className={"tempory-corp-list"}>
        {
          this.state.isView ?
            <Details refreshData={this.getData} closeModal={() => this.viewCorporate(null)}
                     data={this.state.selectObj}/>
            : null
        }
        <Col lg="12">
          <Card>
            <CardHeader>
              <div className={"temp-cor-left"}>
                <span>Pending Approval</span>
                  <span className={"temp-cor-status-lbl"}>| Status:</span>
                <div className={"temp-cor-dropdown"}>
                  <Dropdown
                    fluid selection
                    options={DropDownConst.tempCorporateStatus} value={status}
                    onChange={(event, {value}) => {
                      this.setState({status: value})
                    }}
                  />
                </div>
              </div>
              <div className={"float-right"}>
                <SementicBtn circular icon='refresh' onClick={this.getData}/>
              </div>
            </CardHeader>
            <CardBody>
              <MDBDataTable
                id={"all-corporate-table"}
                searching={true}
                searchLabel={"Search Corporate"}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
